import { useMutation } from '@tanstack/react-query'
import { placeWebsiteApi } from '../api/website-api'

export function useReadPlaceWebsite(businessId: string) {
  return useMutation({
    mutationFn: (input: { url: string; locale: 'de' | 'en' }) =>
      placeWebsiteApi.read(businessId, input),
  })
}
